import { Outlet } from 'react-router-dom';
import { useUI } from '../store/UIContext';
import { ToastContainer } from '../components/ui/index';
import AppBackground from '../components/decoration/AppBackground';

export default function AuthLayout() {
  const { toasts, removeToast } = useUI();
  return (
    <div dir="rtl" style={{ minHeight: '100vh', background: 'var(--surface-2)', position: 'relative' }}>
      <AppBackground />
      <Outlet />
      <ToastContainer toasts={toasts} onRemove={removeToast} />
    </div>
  );
}
